/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';

import useScript from '../../../../hooks/useScript';
import { FINIX_SCRIPT, FinixAuth, createFinixAuth } from '../../../../utils/finix-payout';
import { FinixPaymentInstrumentToken } from '../../../../utils/types/referrer';
import { DealWithFarthestState } from '../../utils';
import PayoutForm from './PayoutForm';

const PayoutAccountDetails = ({
  deal,
  createToken,
  verifyInstrument,
  createMerchant,
  cancelForm,
}: {
  deal: DealWithFarthestState | undefined;
  createToken: (fields: FinixPaymentInstrumentToken) => Promise<any>;
  verifyInstrument: (id?: string) => Promise<void>;
  createMerchant: () => Promise<void>;
  cancelForm?: () => void;
}) => {
  const isLoaded = useScript(FINIX_SCRIPT);
  const isMounted = useRef(false);
  const [finixAuth, setFinixAuth] = useState<FinixAuth | null>(null);
  const [finixError, setFinixError] = useState(false);
  useEffect(() => {
    let cancelled = false;
    const getFinixAuth = async () => {
      try {
        const auth = await createFinixAuth();
        if (!cancelled) setFinixAuth(auth);
      } catch {
        if (!cancelled) setFinixError(true);
      }
    };
    if (isLoaded && !isMounted.current) {
      isMounted.current = true;
      getFinixAuth();
    }
    return () => {
      cancelled = true;
    };
  }, [isLoaded]);
  if (finixError) {
    return (
      <Box fontWeight={700} fontSize={14} color="leaseEndRed">
        Unable to load payment form. Please refresh and try again.
      </Box>
    );
  }
  return finixAuth ? (
    <>
      <PayoutForm
        deal={deal}
        createToken={createToken}
        verifyInstrument={verifyInstrument}
        createMerchant={createMerchant}
        cancelForm={cancelForm}
      />
    </>
  ) : (
    <Box fontWeight={700} fontSize={14} color="#888">
      Hang tight...
    </Box>
  );
};
export default PayoutAccountDetails;
